var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"row row--margin-top"},_vm._l((_vm.packages),function(pkg){return _c('div',{key:pkg.id,staticClass:"col-xs-6"},[_c('package-detail',{attrs:{"offer-package":pkg}})],1)}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3cdeff5b","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./WebResources/vue/shared/components/catalog/YouMayAlsoLike/PackageListing.vue
// module id = 874
// module chunks = 0 2